
//忠诚度管理-会员权益
import { get, post, postJson, put, deleteApi } from '../axios2'

const RESOURCE_BASE_PATH = '/benefitActivity';


//创建会员权益活动
export const createBenefitActivity = p => postJson(`${RESOURCE_BASE_PATH}`, p);

//分页查询会员权益活动
export const queryPage = p => postJson(`${RESOURCE_BASE_PATH}/page`, p);

//分页查询会员权益活动参与记录
export const queryRecordPage = p => postJson(`${RESOURCE_BASE_PATH}/record/page` , p);


//会员权益活动标记为已领取或取消标记
export const signRecord = p => put(`${RESOURCE_BASE_PATH}/record/${p.id}?type=${p.type}`);


//删除会员权益活动
export const deleteBenefitActivity = p => deleteApi(`${RESOURCE_BASE_PATH}/`+ p.id);


//关闭会员权益活动
export const closeBenefitActivity = p => put(`${RESOURCE_BASE_PATH}/`+ p.id);

